
import {createLogger} from '../../common/logging.config';
const logger = createLogger('createContentFilter');


module.exports = [function() {

    // Filter the content type entries based on the kind field
    return function(entries) {
        let filteredEntries = []; // NOSONAR, not constant

        entries.forEach((entry) => {
        	if (entry.kind && entry.kind.includes('standalone')) {
        		filteredEntries.push(entry);
        	}
        	else {
        		logger.info('Filtering out content type: ' + entry.name);
        	}
        });

        return filteredEntries;
    }

}];


// WEBPACK FOOTER //
// ./app/components/createContent/createContent.filter.js